export default __webpack_public_path__ + "static/media/programs.d4148d9c.jpg";